module.exports = __webpack_public_path__ + "img/ivory-coast.d3acedd9.png";